import EDC from '../../../shared/globals';

EDC.Animations.Wiggle = function (scene, roll) {
  this.scene = scene;
  this.roll = roll;
  this.wiggleTween = null;
  return this;
};

EDC.Animations.Wiggle.prototype.startWiggle = function () {
  this.wiggleTween = this.scene.tweens.add({
    targets: this.roll,
    angle: -3,
    duration: 125,
    ease: 'Sine.easeInOut',
    repeat: 8,
    yoyo: true,
    onComplete: this.resetAngle.bind(this),
  });
};

EDC.Animations.Wiggle.prototype.start = function () {
  this.roll.angle = 3;
  this.startWiggle();
};

EDC.Animations.Wiggle.prototype.stop = function () {
  if (this.wiggleTween) {
    if (this.wiggleTween.isPlaying()) {
      this.wiggleTween.stop();
    }
  }
  this.roll.angle = 0;
};

EDC.Animations.Wiggle.prototype.resetAngle = function () {
  this.roll.angle = 0;
};

export default EDC.Animations.Wiggle;
